module.exports = __webpack_public_path__ + "img/impact-in-action@3x.410fd4b8.webp";